import { Button, Paper, Typography } from '@mui/material';
import TravelExploreIcon from '@mui/icons-material/TravelExplore';

import './SimpleWorkingAreaCard.scss';

function SimpleWorkingAreaCard({
  className, description, workingAreaId, handleGoToWorkingAreaDetails, showDetailsLabel
}) {

  function handleClickWorkingAreaDetails() {
    handleGoToWorkingAreaDetails?.(workingAreaId);
  }

  const classNames = `working-area ${className || ''}`;

  return (
    <Paper
      className={classNames}
      elevation={1}>
      <Typography
        className="description"
        variant="p"
        component="p"
      >
        {description}
      </Typography>
      {handleGoToWorkingAreaDetails && (
        <div className="go-to-details-button">
          <TravelExploreIcon />
          <Button onClick={handleClickWorkingAreaDetails}>
            {showDetailsLabel ? 'Detalhes' : ''}
          </Button>
        </div>
      )}
    </Paper>
  )
}

export default SimpleWorkingAreaCard;
